import type { CanvasSectionBlock } from '../sectionRegistry';
import { isSectionBackdropModelViewerBlock } from '../blockRenderers/modelViewerSceneBackdrop';
import {
  isBuilderLayerHidden,
  isBuilderLayerLocked,
  resolveBuilderBlockStyleMeta,
} from './blockFrame';

function isAtmosphereSpacerBlock(block: CanvasSectionBlock): boolean {
  if (block.type !== 'spacer') return false;
  const style = resolveBuilderBlockStyleMeta(block);
  const backgroundOpacity = style.backgroundOpacity;
  const opacityIsZero =
    backgroundOpacity === 0 ||
    backgroundOpacity === '0' ||
    (typeof backgroundOpacity === 'number' && backgroundOpacity <= 0);
  const backgroundImage = style.backgroundImage;
  return (
    opacityIsZero &&
    typeof backgroundImage === 'string' &&
    backgroundImage.includes('gradient')
  );
}

/** Scene/atmosphere blocks use full-bleed or invisible grid anchors — hover boxes confuse layout edits. */
export function shouldSuppressBuilderHoverChrome(block: CanvasSectionBlock): boolean {
  if (isSectionBackdropModelViewerBlock(block)) return true;
  if (isBuilderLayerLocked(block)) return true;
  if (isBuilderLayerHidden(block)) return true;
  if (isAtmosphereSpacerBlock(block)) return true;
  return false;
}
